module.exports = __webpack_public_path__ + "img/close-circle-red.f532d996.svg";